import Vue from 'vue';
import Config from '../configuration';

export default {
    namespaced: true,
    mutations: {

    },
    getters: {

    },
    actions: {
        getSummaryReport (context)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'report/' + self.state.userInfo.SelectedClaimant.ClaimantId, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        }
    }
}
